import * as DOMPurify from "dompurify";
import { mapGetters } from "vuex";

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  computed: {
    ...mapGetters([
      "getAvailableLocales",
      "getSelectedLanguage",
      "getAppLanguage",
    ]),
  },

  methods: {
    sanitizeHTML(html) {
      return DOMPurify.sanitize(html);
    },

    textEquals(name1, name2) {
      return (name1 == null || name1 === "")
        ? (name2 == null || name2 === "")
        : name2 != null && name1.trim().toLowerCase() === name2.trim().toLowerCase();
    },

    textNotEquals(name1, name2) {
      return !this.textEquals(name1, name2);
    },

    isEmptyText(s) {
      return !s || s.trim().length === 0;
    },

    containsEmptyText(...s) {
      return s.some((str) => this.isEmptyText(str));
    },

    stringEquals(s1, s2) {
      return (s1 == null || s1 === "") ? (s2 == null || s2 === "") : s1 === s2;
    },

    stringNotEquals(s1, s2) {
      return !this.stringEquals(s1, s2);
    },

    isInvalidEmail: function(email) {
      return !EMAIL_REGEX.test(email);
    },

    getDefaultLocales() {
      let locales;
      if (this.getAvailableLocales.includes(this.getSelectedLanguage)) {
        locales = [this.getSelectedLanguage];
      } else if (this.getAvailableLocales.includes(this.getAppLanguage)) {
        locales = [this.getAppLanguage];
      } else {
        locales = ["de", "en"];
      }
      return locales;
    },

    addTranslation(translations, translation) {
      const index = translations.findIndex(t => t.locale === translation.locale);
      if (index === -1) {
        translations.push(translation);
      } else {
        translations[index] = translation;
      }
    },
  },
}
